import { render, staticRenderFns } from "./administratorEdit.vue?vue&type=template&id=5e4cd5aa&scoped=true&"
import script from "./administratorEdit.vue?vue&type=script&lang=js&"
export * from "./administratorEdit.vue?vue&type=script&lang=js&"
import style0 from "./administratorEdit.vue?vue&type=style&index=0&id=5e4cd5aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4cd5aa",
  null
  
)

export default component.exports